import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import ALPIcon from '../../../ExperienceCatalog/Experience/OfferingType/AdvancedLeaderProgram/ALPIcon';

interface Props {
  children?: React.ReactNode;
}

function ALPLabel({ children }: Props) {
  return (
    <div className="relative w-min flex items-center rounded-2xl border-purple-800 text-purple-800 px-3 py-1 text-xs border">
      <span className="mr-2">
        <ALPIcon />
      </span>
      <span className="mr-2">
        <T kind="ALP" />
      </span>
      {children}
    </div>
  );
}

export default observer(ALPLabel);
